import { ApiService, BASE_URL } from "../../../../services/base-service/api.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Injector } from "@angular/core";

@Injectable()
export class PassbookService extends ApiService<any, any, any> {
    urlPath: string = 'passbook';
    constructor(private Http: HttpClient, private Injector: Injector) {
        super(Http, Injector);
    }
}
